import React from "react";
import { Outlet } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { Box } from "@mui/material";
import Encabezado from "./Encabezado/Encabezado";
import PieDePagina from "./PieDePagina/PieDePagina";
import WhatsAppButton from "../../ui/WhatsAppButton";
import ScrollToTop from "../../utils/ScrollToTop";
import { publicTheme } from "../../../theme/publicTheme";

export default function PublicLayout() {
  return (
    <ThemeProvider theme={publicTheme}>
      <ScrollToTop />
      <Box
        className="public-page-root"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          justifyContent: "flex-start",
          position: "relative",
          paddingBottom: 0,
          minHeight: "100vh",
          width: "100%",
          maxWidth: "100%",
          overflowX: "hidden",
        }}
      >
        <div className="background"></div>
        <Encabezado />

        <Box component="main" sx={{ flexGrow: 1, width: "100%" }}>
          <Outlet />
        </Box>

        <PieDePagina />
        {/* Botón de Whatsapp deshabilitado temporalmente */}
        {/* <WhatsAppButton /> */}
      </Box>
    </ThemeProvider>
  );
}
